<template>
    <div class="gray-back" >
        <van-divider>如有信息需要修改，请加微信联系CCA工作人员</van-divider>
        <div v-for="src in imgs" v-if="imgs.length>0" style="
            text-align: center;
            margin: 10px;
        ">
            <img style="
            width: 100%;"  :src="src"/>
        </div>
        <div  style="
            text-align: center;
            margin: 10px;
        " v-if="imgs.length==0" >工作人员二维码未配置</div>
    </div>
</template>

<style scoped="">
</style>
<script>
    import {
            Cell, CellGroup,Field,RadioGroup,Radio,DatetimePicker,Picker,NoticeBar,Button,Dialog
    } from 'vant';
    export default {
        name: 'qrcode1',
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Field.name]: Field,
            [DatetimePicker.name]: DatetimePicker,
            [Picker.name]: Picker,
            [NoticeBar.name]: NoticeBar,
            [Button.name]: Button,
            [Dialog.name]: Dialog,
        },
        data: function () {
            return {
                pageData:{
                    'id' : this.$route.query.id,
                    'jiankangpics' :[],
                    'lingdui_list' :[],
                    'yundongyuan_list' :[],
                    'jiaolianyuan_list' :[],
                    'caipanyuan_list' :[]
                },
                formData:{
                    'id' : this.$route.query.id,
                },
                imgs:[],
                showTime:false,
                timeField:'',
                showStation:false,
                stationField:'',
            }
        },
        mounted: function () {
            let that = this;
            document.title = "秩序册信息修改";
            this.$api.get('/api/sai/confirmzhixucedetail', {
                'id':that.pageData.id
            }, r => {
                that.pageData = r.data;
                if(that.pageData.erweiimg2){
                    that.imgs =  that.pageData.erweiimg2;
                }
            });

        },
        methods: {
        }
    }
</script>


// WEBPACK FOOTER //
// SaiConfirmQr1.vue?fc0d7484